import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
    Button,
    Card,
    Col,
    Container,
    Form,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Spinner,
} from "reactstrap";
import { configActions } from "redux/actions";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useAddLocationFeature, useUpdateLocationFeature } from "hooks/useConfig";
import { api } from "helpers";
import { useDeleteLocationFeature } from "hooks/useConfig";
import { PROPERTY_TYPE_VALUE } from "utils";
import NotFound from "components/NotFound/NotFound";
import { HiOutlinePlusCircle } from "react-icons/hi";
import { FiEdit } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";

const featureSchema = yup.object().shape({
    feature: yup.string().required(),
    description: yup.string().required(),
    image: yup.mixed().required(),
});

const LocationFeature = () => {
    const dispatch = useDispatch();
    const [amenityTypeId, setAmenityTypeId] = useState("1");
    const [updateAble, setUpdateAble] = useState(true);
    const [updateableId, setUpdateableId] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { locationfeature, loading } = useSelector(state => state.getLocationFeatureReducer);
    useEffect(() => {
        dispatch(configActions.getLocationFeatureByPropertyType(amenityTypeId));
    }, []);
    useEffect(() => {
        if (isModalOpen == false) {
            dispatch(configActions.getLocationFeatureByPropertyType(amenityTypeId));
        }
    }, [isModalOpen]);

    const { mutate } = useAddLocationFeature()
    const { mutate: mutateLocationFeature } = useUpdateLocationFeature();
    const { mutate: deleteLocationFeature } = useDeleteLocationFeature()
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm({ resolver: yupResolver(featureSchema) });

    const handleAddFeature = () => {
        setIsModalOpen(true);
        setUpdateAble(false);
        reset();
    };

    const handleDelete = async (id) => {
        const sure = window.confirm("Are you Sure to Delete?");

        if (sure) {
            await deleteLocationFeature(
                { id: id },
                {
                    onSuccess: async (res) => {
                        dispatch(configActions.getLocationFeatureByPropertyType(amenityTypeId));
                    },
                    onError: (error) => {
                        console.log(error)
                    }
                }
            );
        }
    };

    const handleUpdate = (amenity) => {
        setIsModalOpen(true);
        setUpdateAble(true);
        setValue("feature", amenity.name);
        setValue("description", amenity.description);
        setUpdateableId(amenity?.id);
    };

    const handleAmintyChange = (e) => {
        setAmenityTypeId(e.target.value);
        dispatch(configActions.getLocationFeatureByPropertyType(e.target.value));
    };

    const onSubmit = async (data) => {
        let dataNew = {
            property_type_id: amenityTypeId,
            name: data.feature,
            description: data.description,
            id: updateableId
        }
        if (!updateAble) {
            if (data?.image[0]?.type !== "image/png") {
                toast.error("PNG image Allowed only");
                return;
            }
        }
        if (data?.image[0]) {
            const formDataNew = new FormData();
            formDataNew.append("file", data?.image[0])
            try {
                const res = await api.post("/file",
                    formDataNew
                );
                dataNew.icon = res?.url
            } catch (ex) {
                console.log(ex);
                return;
            }
        }
        if (updateAble) {
            await mutateLocationFeature(
                dataNew,
                {
                    onSuccess: async (res) => {
                        setTimeout(() => {
                            dispatch(configActions.getLocationFeatureByPropertyType(amenityTypeId));
                            toast.success("Location Feature updated successfully");
                        }, 1000);
                    },
                    onError: (error) => {
                        console.log(error)
                    }
                }
            );
        } else {
            await mutate(
                dataNew,
                {
                    onSuccess: async (res) => {
                        setTimeout(() => {
                            dispatch(configActions.getLocationFeatureByPropertyType(amenityTypeId));
                            toast.success("Location Feature added successfully");
                        }, 1000);
                    },
                    onError: (error) => {
                        console.log(error)
                    }
                }
            );
        }
        reset();
        setIsModalOpen(false);
    };

    return (
        <>
            <Container fluid className="mt-5 px-md-5 px-1 ">
                <h2 className="rz-heading rz-text-20">Add New Location Feature </h2>
                <Card className="card bg-white p-4  ">
                    <label className="form-label">Type* </label>
                    <Row>
                        <Col xs="12" md="7">
                            <select onChange={handleAmintyChange} className="form-control">
                                <option value={`${PROPERTY_TYPE_VALUE?.LANDPARCEL}`}>Land Parcel</option>
                                <option value={`${PROPERTY_TYPE_VALUE?.RESIDENTIAL}`}>Residential</option>
                                <option value={`${PROPERTY_TYPE_VALUE?.COMMERCIAL}`}>Commercial</option>
                                <option value={`${PROPERTY_TYPE_VALUE?.HOLIDAY_HOME}`}>Holiday Home</option>
                                {/* <option value={`${PROPERTY_TYPE_VALUE?.AGRICULTURE_LAND}`}>Agriculture Land</option> */}
                            </select>
                        </Col>
                        <Col>
                            <Button
                                onClick={handleAddFeature}
                                className="rz-button-primary"
                            >
                                <HiOutlinePlusCircle className="mr-2" style={{ fontSize: "20px" }} /> Add New Feature
                            </Button>
                        </Col>
                    </Row>
                    <hr />

                    {loading ? (
                        <Row>
                            <Col md="7" xs="12" className="text-center">
                                <div colSpan="10">
                                    <Spinner animation="border" role="status" >{null}</Spinner>
                                </div>
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            {locationfeature?.map((signleAmenity) => {
                                return (
                                    <Col md="7" xs="12" className="my-3">
                                        <Row>
                                            <Col xs="1" md="1">
                                                <img width="30" src={signleAmenity?.icon} alt="" />
                                            </Col>
                                            <Col xs="6" md="7">
                                                {signleAmenity?.name}
                                            </Col>
                                            <Col className="d-flex justify-content-end" xs="4" md="4">
                                                <div
                                                    onClick={() => handleUpdate(signleAmenity)}
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#exampleModal"
                                                >
                                                    <FiEdit style={{ fontSize: "20px" }} className="ryzer-text-blue cursor-pointer" />
                                                </div>
                                                <div
                                                    onClick={() => handleDelete(signleAmenity?.id)}
                                                >
                                                    <AiOutlineDelete style={{ fontSize: "22px" }} className="ryzer-text-blue ml-3 cursor-pointer" />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                );
                            })}
                        </Row>
                    )}
                    {locationfeature?.length <= 0 &&
                        <NotFound
                            message="Add first Location feature for Selected Asset Type."
                        />
                    }
                    <Modal isOpen={isModalOpen} centered={true} className="modal-lg">
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <div className="px-4 pt-4 d-flex justify-content-between">
                                <div>
                                    <h1 className="rz-heading rz-text-18" id="exampleModalLabel">
                                        Add New Feature
                                    </h1>
                                </div>
                                <div>
                                    <Button
                                        type="button"
                                        className="btn-close btn-link bg-white"
                                        onClick={() => setIsModalOpen(false)}
                                    >
                                        <i className="fas fa-times    "></i>
                                    </Button>
                                </div>
                            </div>
                            <ModalBody>
                                <FormGroup>
                                    <Label className="form-label" htmlFor={`question`}>
                                        Title
                                    </Label>
                                    <input
                                        className="form-control mb-3"
                                        type="text"
                                        placeholder="Feature New"
                                        {...register("feature", {})}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label className="form-label" htmlFor={`description`}>
                                        Description
                                    </Label>
                                    <input
                                        className="form-control mb-3"
                                        type="text"
                                        placeholder="Description for feature New"
                                        {...register("description", {})}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label className="form-label" htmlFor={`answer`}>
                                        Attachment <br />
                                        <small> (Allowed PNG format only) </small>
                                    </Label>

                                    <div className="custom-file">
                                        <input
                                            className="custom-file-input"
                                            id="customFile"
                                            type="file"
                                            placeholder="image"
                                            accept="image/*"
                                            {...register("image", {})}
                                        />
                                        <label className="custom-file-label" for="customFile">
                                            Choose file
                                        </label>
                                    </div>
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <Button className="rz-button-outline-primary" onClick={() => setIsModalOpen(!isModalOpen)}>
                                    Cancel
                                </Button>

                                <Button className="rz-button-primary ml-3">Save</Button>
                            </ModalFooter>
                        </Form>
                    </Modal>
                </Card>
            </Container>
        </>
    );
};

export default LocationFeature;
